import { IPROP_MAP } from '../../generators/modifyProps';
import { JDSFooterProps } from './generated';
import { LinkProps } from '../jdslink/logic';

interface FooterLinkProps extends LinkProps {
  subLinks?: LinkProps[];
}

export interface FooterProps
  extends Omit<
    JDSFooterProps,
    'marketplace' | 'logo' | 'links' | 'social' | 'copyright'
  > {
  links?: FooterLinkProps[];
  /**
   * @deprecated use links
   */
  mainLinks?: { heading: string; links: FooterLinkProps }[];
  social?: {
    title: string;
    links?: {
      icon: string | JSX.Element;
    }[];
  };
  copyright?: JDSFooterProps['copyright'];
  marketplace?: {
    title?: string;
    stores?: Array<{
      badgeAsset: string;
      href: string;
    }>;
  };
}

export const PROP_MAP: IPROP_MAP<FooterProps> = (props) => ({
  marketplace: {
    properties: {
      title: props.marketplace?.title,
      assets: props.marketplace?.stores?.map((store) => ({
        image: store.badgeAsset,
        href: store.href
      }))
    }
  },
  mainLinks: {
    properties: {
      links: props.mainLinks?.map((l) => ({
        title: l.heading,
        subLinks: l.links
      }))
    }
  }
});
